import "./style.css";
import ScrollAnimation from "react-animate-on-scroll";

export const WordContainer = ({ word }) => {
    return (
        <ScrollAnimation
            animateIn="fadeInLeft"
            duration={0.5}>
            <div className="base_container mx-2 px-2">
                <div className="my-1">
                    {word}
                </div>
            </div>
        </ScrollAnimation>

    )
}